// Central content store for Spazio Isa
// All copy extracted from the client's brief. Do not translate.

export const SITE = {
    name: "Spazio Isa",
    tagline: "Centro Estetico — Livorno",
    address: {
        street: "Via A. Minghi 30",
        cap: "57124",
        city: "Livorno",
        district: "Quartiere Coteto",
    },
    phone: "0586 073463",
    mobile: "340 8462994",
    phoneHref: "tel:+390586073463",
    mobileHref: "tel:+393408462994",
    whatsappHref: "https://wa.me/393408462994",
    facebookUrl:
        "https://www.facebook.com/isaspazio.hotmail.it/?locale=it_IT",
    instagramUrl:
        "https://www.instagram.com/centro_estetico_spazioisa/",
    hours: [
        { day: "Lunedì", value: "Chiuso" },
        { day: "Martedì — Venerdì", value: "09:00 – 18:30" },
        { day: "Sabato", value: "09:00 – 13:00" },
        { day: "Domenica", value: "Chiuso" },
    ],
    mapEmbed:
        "https://www.google.com/maps?q=Via%20A.%20Minghi%2030%2C%20Livorno&output=embed",
};

export const NAV = [
    { label: "Home", to: "/" },
    { label: "Estetica", to: "/estetica" },
    {
        label: "Servizi",
        to: "#",
        children: [
            { label: "Pressoterapia", to: "/pressoterapia" },
            { label: "Epilazione Laser", to: "/laser" },
            { label: "Infrarossi Viso", to: "/infrarossi" },
            { label: "Radiofrequenza Viso", to: "/radiofrequenza" },
        ],
    },
    { label: "Nail Art", to: "/nail-art" },
    { label: "Gelinium", to: "/gelinium" },
    { label: "Prodotti", to: "/prodotti" },
    { label: "Contatti", to: "/contatti" },
];

// Hero images map (desktop + mobile in /public/images)
export const HERO_IMG = {
    home: {
        d: "/images/hero-desktop/HomeDesktop.webp",
        m: "/images/hero-mobile/HomeMobile.webp",
    },
    estetica: {
        d: "/images/hero-desktop/EsteticaDesktop.webp",
        m: "/images/hero-mobile/EsteticaMobile.webp",
    },
    pressoterapia: {
        d: "/images/hero-desktop/PressoterapiaDesktop.webp",
        m: "/images/hero-mobile/PressoterapiaMobile.webp",
    },
    laser: {
        d: "/images/hero-desktop/LaserDesktop.webp",
        m: "/images/hero-mobile/LaserMobile.webp",
    },
    infrarossi: {
        d: "/images/hero-desktop/InfrarossiDesktop.webp",
        m: "/images/hero-mobile/InfrarossiMobile.webp",
    },
    radiofrequenza: {
        d: "/images/hero-desktop/RadiofrequenzaDesktop.webp",
        m: "/images/hero-mobile/RadiofrequenzaMobile.webp",
    },
    nailart: {
        d: "/images/hero-desktop/NailArtDesktop.webp",
        m: "/images/hero-mobile/NailArtMobile.webp",
    },
    gelinium: {
        d: "/images/hero-desktop/GeliniumDesktop.webp",
        m: "/images/hero-mobile/GeliniumMobile.webp",
    },
    prodotti: {
        d: "/images/hero-desktop/ProdottiDesktop.webp",
        m: "/images/hero-mobile/ProdottiMobile.webp",
    },
    contatti: {
        d: "/images/hero-desktop/ContattiDesktop.webp",
        m: "/images/hero-mobile/ContattiMobile.webp",
    },
};

// Editorial photos (FotoSparse)
export const PHOTO = {
    curaMani: "/images/foto/CuraMani.webp",
    curaPelle: "/images/foto/CuraPelle.webp",
    curaViso: "/images/foto/CuraViso.webp",
    curaViso2: "/images/foto/CuraViso2.webp",
    dialogo: "/images/foto/Dialogo.webp",
    donnaRilassata: "/images/foto/DonnaRilassata.webp",
    donnaRilassata2: "/images/foto/DonnaRilassata2.webp",
    infrarossi: "/images/foto/Infrarossi.webp",
    laserGambe: "/images/foto/LaserGambe.webp",
    mani: "/images/foto/Mani.webp",
    pressoterapia: "/images/foto/Pressoterapia.webp",
    prodottiVari: "/images/foto/ProdottiVari.webp",
    puliziaViso: "/images/foto/PuliziaViso.webp",
    radioFrequenza: "/images/foto/RadioFrequenza.webp",
};

// Common CTAs
export const CTA = {
    primary: { label: "Prenota un appuntamento", href: "/contatti" },
    secondary: { label: "Richiedi informazioni", href: "/contatti" },
};
